<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable width="400">

      <v-card>

        <v-card-title>
          Animateurs
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-0">

          <v-list dense>
            <template v-for="(item, index) in animators">
              <v-list-item :key="index" link @click="$refs.salesDialog.open(item)">

                <v-list-item-avatar v-if="item.photo" left size="40">
                  <v-img :src="$baseUrl + item.photo"
                         class="zoom-pointer"
                         @click="$refs.lightbox.open(item.photo)"></v-img>
                </v-list-item-avatar>

                <v-list-item-avatar v-else
                                    :class="$func.randomColor()"
                                    class="font-weight-medium"
                                    left
                                    size="40"
                >
                  {{ $func.avatarName(item.name) }}
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="item.phone"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-chip class="bg-blue-subtle font-weight-medium cursor-pointer"
                          small
                          text-color="blue">
                    <v-icon color="blue" left small>mdi-shopping</v-icon>
                    {{ item.sales_count }}
                    <v-icon color="blue" right small>mdi-arrow-right</v-icon>
                  </v-chip>
                </v-list-item-action>

              </v-list-item>

              <v-divider
                  v-if="index < animators.length - 1"
                  :key="'key-'+index"
              ></v-divider>
            </template>
          </v-list>

        </v-card-text>
      </v-card>
    </v-dialog>

    <Lightbox ref="lightbox"/>
    <SalesDialog ref="salesDialog"/>

  </div>
</template>

<script>
import SalesDialog from "@/views/v2_campaigns/components/SalesDialog.vue";

export default {
  components: {
    SalesDialog
  },
  data() {
    return {
      dialog: false,
      animators: []
    }
  },
  methods: {
    open(animators) {
      this.animators = animators
      this.dialog = true
    },
  },
}
</script>

<style scoped>

</style>